<template>
  <div class="advantages-wrap moveRight" :style="{backgroundColor: bgcolor}">
    <div class="advantages-inner">
      <h2>PBSD 产品优势</h2>
      <h3>Advantage of PBSD</h3>
      <AdvantageItems/>
      <!-- <button class="pr-btn dark-btn" @click="goDetail" v-if="isShowBtn">了解更多</button> -->
    </div>
  </div>
</template>
<script>
import AdvantageItems from '@/components/AdvantageItems.vue'

export default {
  name: 'home',
  props: {
    bgcolor: {
      type: String,
      default: '#ffffff'
    },
    isShowBtn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AdvantageItems
  },
  methods: {
    goDetail() {
      this.$router.push('detail')
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../css/animation');
.advantages-wrap {
  font-family: "Microsoft YaHei";
  position: relative;
  .advantages-inner {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    padding: 40px;
  }
  h2 {
    font-size: 30px;
    // font-weight: 600;
    color: #000;
    line-height: 42px;
    margin-bottom: 4px;
    margin-top: 8px;
  }
  h3 {
    font-size: 19px;
    // font-weight: 600;
    color: #000;
    line-height: 26px;
    margin-bottom: 30px;
  }
  .dark-btn {
    padding: 7px 40px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
